import type { ExerciseProgress, Submission } from '@/submissions/types';

export interface SubmissionSummaryDerived {
    successfulDistinct: number;
    progressEnabledPercent: number;
    progressCoursePercent: number;
    solvedEnabledLabel: string | undefined;
    solvedCourseLabel: string | undefined;
}

/**
 * Agrega métricas para Mis Envíos: ejercicios distintos con éxito y % de progreso
 * sobre ejercicios habilitados y sobre el total de la cursada.
 */
export function computeSubmissionSummaryStats(
    submissions: Submission[],
    exerciseProgress: ExerciseProgress | undefined,
): SubmissionSummaryDerived {
    const distinctKeys = new Set<string>();
    for (const s of submissions) {
        if (s.success) distinctKeys.add(`${s.guideNumber}-${s.exerciseNumber}`);
    }
    const successfulDistinct = exerciseProgress?.solvedCourseDistinct ?? distinctKeys.size;

    const ep = exerciseProgress;
    const progressEnabledPercent =
        ep && ep.enabledTotal > 0
            ? Math.min(100, Math.round((ep.solvedEnabledDistinct / ep.enabledTotal) * 100))
            : 0;
    const progressCoursePercent =
        ep && ep.courseTotal > 0
            ? Math.min(100, Math.round((ep.solvedCourseDistinct / ep.courseTotal) * 100))
            : 0;

    return {
        successfulDistinct,
        progressEnabledPercent,
        progressCoursePercent,
        solvedEnabledLabel: ep ? `${ep.solvedEnabledDistinct}/${ep.enabledTotal}` : undefined,
        solvedCourseLabel: ep ? `${ep.solvedCourseDistinct}/${ep.courseTotal}` : undefined,
    };
}
